"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeSpanProcessor = void 0;
class AttributeSpanProcessor {
    constructor(attributes) {
        this._attributes = attributes;
    }
    // Implement onStart to apply span attributes before exporting
    onStart(span) {
        span.setAttributes(this._attributes);
    }
    onEnd() {
        return;
    }
    shutdown() {
        return Promise.resolve();
    }
    forceFlush() {
        return Promise.resolve();
    }
}
exports.AttributeSpanProcessor = AttributeSpanProcessor;
//# sourceMappingURL=attributeSpanProcessor.js.map